import { render, staticRenderFns } from "./EditalNavbar.vue?vue&type=template&id=a268a404&scoped=true&lang=pug&"
import script from "./EditalNavbar.vue?vue&type=script&lang=js&"
export * from "./EditalNavbar.vue?vue&type=script&lang=js&"
import style0 from "./EditalNavbar.vue?vue&type=style&index=0&id=a268a404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a268a404",
  null
  
)

export default component.exports